import { View, createStyleSheet, useStyleSheet } from '@gopeerproject/ui-kit';
import React from 'react';
export const InsetLines = ({ item, index, flatList }) => {
    const styles = useStyleSheet(getStyles);
    return (React.createElement(React.Fragment, null, Array.from(new Array(item.insetLevel)).map((_, i, arr) => {
        let connectToNext = false;
        for (let j = index + 1; j < flatList.length; j++) {
            if (flatList[j].insetLevel === i + 1) {
                connectToNext = true;
                break;
            }
            if (flatList[j].insetLevel <= i)
                break;
        }
        return (React.createElement(View, { style: [styles.inset, connectToNext && styles.inset__conn], key: i }, i === arr.length - 1 && (React.createElement(View, { style: [
                styles.insetPointerContainer,
                connectToNext && styles.insetPointerContainer__conn
            ] },
            React.createElement(View, { style: styles.insetPointer })))));
    })));
};
const getStyles = createStyleSheet(({ size, color }) => ({
    inset: {
        width: size.J + 1,
        marginRight: size.B + 1
    },
    inset__conn: {
        borderRightWidth: size.A,
        borderColor: color.invert2.p4
    },
    insetPointerContainer: {
        left: size.J + 1,
        width: size.B + 1,
        top: 0,
        height: '50%',
        position: 'absolute'
    },
    insetPointerContainer__conn: {
        overflow: 'hidden'
    },
    insetPointer: {
        right: 0,
        width: '7px',
        height: '100%',
        position: 'absolute',
        borderBottomWidth: size.A,
        borderLeftWidth: size.A,
        borderBottomLeftRadius: 100,
        borderColor: color.invert2.p4
    }
}));
//# sourceMappingURL=InsetLines.js.map